const _excluded = ["title", "description", "action", "footer", "onLogout", "homeUrl", "illustrationType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import A from '@adsk/alloy-react-a';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import ErrorPage from '../ErrorPage';
const DefaultAction = _ref => {
  let {
    homeUrl
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(A, {
    href: homeUrl,
    style: theme.typography.heading2
  }, T.translate('GO_HOME'));
};
DefaultAction.defaultProps = {
  homeUrl: '/'
};
DefaultAction.propTypes = {
  homeUrl: PropTypes.string
};
/**
 * A PageNotFound component. Used to show a generic "page not found" error.
 * Can be used as a fallback for unknown routes for example.
 */
const PageNotFound = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
      title,
      description,
      action,
      footer,
      onLogout,
      homeUrl,
      illustrationType = ErrorPage.ILLUSTRATION_TYPES.SKYLINE_GREY
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  const {
    T
  } = useLocale(_ref4 => {
    let {
      locale
    } = _ref4;
    return require("../i18n/".concat(locale, ".json"));
  });
  const finalTitle = title || T.translate('PAGE_NOT_FOUND_TITLE');
  const finalDescription = description || T.translate('PAGE_NOT_FOUND_DESCRIPTION');
  const finalAction = action || /*#__PURE__*/React.createElement(DefaultAction, {
    homeUrl: homeUrl
  });
  const finalFooter = footer || T.translate('404_ERROR');
  return /*#__PURE__*/React.createElement(ErrorPage, _extends({
    onLogout: onLogout,
    ref: ref,
    title: finalTitle,
    illustrationType: illustrationType,
    description: finalDescription,
    action: finalAction,
    footer: finalFooter
  }, props));
});
PageNotFound.displayName = 'PageNotFound';
PageNotFound.propTypes = _objectSpread(_objectSpread({}, ErrorPage.propTypes), {}, {
  homeUrl: PropTypes.string
});
export default Object.assign(PageNotFound, {
  ILLUSTRATION_TYPES: ErrorPage.ILLUSTRATION_TYPES
});
//# sourceMappingURL=PageNotFound.js.map